export default __webpack_public_path__ + "media/projects/yellow2-65234f44.svg";